import React, { useEffect, useState } from 'react';

import * as Yup from 'yup';
import { t } from 'i18next';
import { useFormik } from 'formik';

import toast from 'react-hot-toast';
import { Close } from '@mui/icons-material';
import { EditIcon } from '../../../../assets/images/icons'; // Replace with correct import for the icon
import { useDispatch, useSelector } from 'react-redux';

import Button from '../../Buttons/Button/Button';
import styles from './EditEducation.module.css';
import Subtitle from '../Subtitle/Subtitle';
import BasicPopup from '../../Popups/BasicPopup/BasicPopup';
import { updateUser } from '../../../../services/userService';
import { fetchUserByToken, fetchUserByTokenWithoutLoading } from '../../../../app/features/userSlice';
import EducationForm from '../../../Forms/Common/EducationForm/EducationForm';
import EducationList from '../Education/EducationList/EducationList';

function EditEducation({ jobseeker }) {
    let user = jobseeker
    useEffect(() => {
        user = jobseeker
        formik.setFieldValue('education', user?.education ? user?.education : []);
    }, [jobseeker])
    const [formLoading, setFormLoading] = useState(false);
    const [editMode, setEditMode] = useState(true)
    const [isOpenWorkExperiencePopup, setIsOpenWorkExperiencePopup] = useState(false);
    const [isOpenEducationPopup, setIsOpenEducationPopup] = useState(false);

    const userToken = useSelector(state => state.user.token);
    const dispatch = useDispatch()

    const formik = useFormik({
        initialValues: {
            education: user?.education ? user?.education : [],

        },
        validationSchema: Yup.object({
        }),
        onSubmit: (values) => {
            if (formLoading) {
                return;
            }
            setFormLoading(true);
            const formData = new FormData();
            formData.append('token', userToken); // Assuming you have user token

            if (values.education.length > 0) {
                values.education.forEach((education, index) => {

                    if (index < 5) {

                        if (education?.action === 'add_new') {
                            formData.append(`education[${index}][institution]`, education.institution);
                            formData.append(`education[${index}][education_level]`, education.education_level);
                            formData.append(`education[${index}][education_title]`, education.education_title);
                            formData.append(`education[${index}][diploma]`, education.diploma);
                            formData.append(`education[${index}][start]`, education.startDate);
                            formData.append(`education[${index}][end]`, education.endDate);
                            formData.append(`education[${index}][id]`, 0);
                        }
                        else {
                            formData.append(`education[${index}][id]`, education.id);
                        }

                    }
                });
            }
            else {
                formData.append('education', '');
            }
            toast.promise(updateUser(formData), {
                loading: t('edit_profile.updating_profile'),
                success: <b>{t('edit_profile.profile_updated')}</b>,
                error: (err) => <b>{err.response.data.error}</b>,
            }).then(async () => {
                await dispatch(fetchUserByTokenWithoutLoading(userToken));
                await setEditMode(!editMode)
                await setFormLoading(false);
            })
                .catch((error) => {
                    setFormLoading(false);
                    if (error?.response?.data?.field) {
                        formik.setErrors({
                            [error.response.data.field]: error.response.data.error
                        });
                    }
                });
        },
    });
    const handlePopupClose = (popupName) => {
        setIsOpenEducationPopup(false);
    }

    const handlePopupOpen = (popupName) => {
        setIsOpenEducationPopup(true);
    }
    const handleOptionRemove = (field, id) => {
        const filteredField = formik.values[field].filter((option) => option.id !== id);
        formik.setFieldValue(field, filteredField);
    }

    const handleAddEducation = (values) => {
        formik.setFieldValue('education', [...formik.values.education, { id: Date.now(), action: 'add_new', ...values }]);
        handlePopupClose('education');
    }

    return (
        <div className={styles.container}>
            {/* Second Column */}
            <div className={styles.secondColumn}>
                {!editMode &&
                    <Close
                        className={styles.mobileIcon}
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={() => { setEditMode(!editMode) }}
                    />}
                <div className={styles.title}>
                    {t(`profileSidebar.tabs.education`)}
                </div>
                {editMode ?
                    <>
                        <div className={styles.aboutTitle}></div>
                        <EducationList education={formik.values.education} />
                    </>
                    :
                    <div className={styles.editContainer}>
                        <div className={styles.aboutTitle}></div>
                        <Subtitle
                            dark
                            hasButton
                            buttonText={t('general.UI.add')}
                            buttonOnClick={() => handlePopupOpen('education')}
                        >
                            {t('general.UI.education')}
                        </Subtitle>
                        <EducationList education={formik.values.education} onRemove={handleOptionRemove} />
                        <Button onClick={formik.submitForm} className={styles.saveButton} >
                            {formLoading ? t('general.UI.loading') : t('general.UI.save')}
                        </Button>
                    </div>
                }
            </div>


            {isOpenEducationPopup &&
                <BasicPopup
                    isOpen={isOpenEducationPopup}
                    closePopup={() => handlePopupClose('education')}
                >
                    <EducationForm onSubmit={handleAddEducation} />
                </BasicPopup>
            }
            <div className={styles.thirdColumn}>
                {!editMode ?
                    <Close
                        className={styles.crossIcon}
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            setEditMode(!editMode)
                            formik.setFieldValue('education', user?.education ? user?.education : [])
                        }}
                    /> :

                    <img
                        src={EditIcon}
                        onClick={() => setEditMode(!editMode)}
                        alt={t('personalInformation.edit')}
                        className={styles.editIcon}
                    />
                }
            </div>
        </div >
    );
}

export default EditEducation;
